import React from "react";
import PropTypes from "prop-types";
import Spinner from "../common/Spinner";

function RecipeTable({ recipes, select }) {
  if (!recipes.length) {
    return <Spinner />;
  }

  return (
    <table className="table">
      <thead>
        <tr>
          <th>Recipe</th>
        </tr>
      </thead>
      <tbody>
        {recipes.map((recipe) => {
          if (recipe.slug) {
            return (
              <tr key={recipe._id}>
                <td onClick={() => select(recipe._id)}>{recipe.title}</td>
              </tr>
            );
          } else {
            return (
              <tr key={recipe._id}>
                <td>{recipe.title}</td>
              </tr>
            );
          }
        })}
      </tbody>
    </table>
  );
}

RecipeTable.propTypes = {
  recipes: PropTypes.array.isRequired,
  select: PropTypes.func.isRequired,
};

export default RecipeTable;
